import { React } from 'react'
import styled from 'styled-components'
import moneyImg from '../../assets/dollarLogo.png'
import CO2Img from '../../assets/CO2.png'
import trashImg from '../../assets/trash.png'
import colors from '../../styles/colors'

const StyledImg = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    img {
        padding: 3px;
        width: 30px;
        object-fit: scale-down;
    }
`
const StyledValues = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    font-size: 100%;
    font-weight: 400;
`
const StyledUnits = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-around;
`
const StyledUserImpact = styled.div`
    display: flex;
    justify-content: space-between;
    width: ${(props) => props.width || '180px'};
    height: 120px;
    border-radius: 2vh;
    background-color: ${colors.second};
    color: white;
    padding: 15px;
    font-size: 100%;
    box-shadow: 0 0 30px grey;
`

function UserImpact({ userInfo, width }) {
    return (
        <StyledUserImpact width={width}>
            <StyledImg>
                <img src={moneyImg} alt="money" />
                <img src={CO2Img} alt="CO2" />
                <img src={trashImg} alt="trash" />
            </StyledImg>
            <StyledValues>
                <div>+&nbsp;{userInfo?.impactMoney || 0}</div>
                <div>-&nbsp;{userInfo?.impactCO2 || 0}</div>
                <div>-&nbsp;{userInfo?.impactTrash || 0}</div>
            </StyledValues>
            <StyledUnits>
                <div>CHF</div>
                <div>kg</div>
                <div>kg</div>
            </StyledUnits>
        </StyledUserImpact>
    )
}

export default UserImpact
